import { render, staticRenderFns } from "./VoteWorks.vue?vue&type=template&id=59785c17"
import script from "./VoteWorks.vue?vue&type=script&lang=js"
export * from "./VoteWorks.vue?vue&type=script&lang=js"
import style0 from "./VoteWorks.vue?vue&type=style&index=0&id=59785c17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports